<template>
<div class="container py-4">
	<div class="container px-md-5">
		<div class="row form-wrapper d-flex flex-column">
			<h1>Help</h1>
			<p>How to search with RDAP</p>
			<p><strong>Query types</strong></p>
			<p>With this tool you can find resource registry data by searching for:</p>
			<ul>
				<li>IP address: You can search for
					<ul>
						<li>An IPv4 address [203.119.42.1], or an</li>
						<li>An IPv6 address [2001:dc0:2000::]</li>
						<li>A CIDR block [202.12.31.0/24] [2001:dc0:2000::/35]</li>
					</ul>
				</li>
				<li>Autonomous System Numbers [AS4608 or just 4608]</li>
				<li>Entity: If you know the handle of an entity you can search for it directly [NO4-AP]</li>
			</ul>
		</div>
	</div>
</div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
